// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles' // Import useTheme

// ** Custom Imports
import { fechaCorta } from 'src/utils/fechas'

// ** Styled Components
import { Divider } from '@mui/material'
import CustomHeader from 'src/@core/components/Header'
import { releaseNotes } from 'src/data/general/releaseNotes'
import { Icon } from '@iconify/react'

const ReleaseNotes = props => {
  const theme = useTheme() // Access the theme

  return (
    <>
      {/* Header Card */}
      <Card
        sx={{
          padding: '1rem 2rem',
          borderRadius: '12px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          marginBottom: '2rem',
          borderTop: '6px solid',
          borderTopColor: 'primary.main'
        }}
      >
        <CustomHeader icon='releases' title='RELEASE NOTES' />
        <Divider sx={{ marginY: '1rem' }} />
        <Typography variant='h6' component='h2' sx={{ fontWeight: 'bold', marginBottom: '1rem', color: theme.palette.primary.main }}>
          WaoTools V2 WebApp
        </Typography>
        <Typography variant='body2' sx={{ marginBottom: '1rem', color: theme.palette.text.secondary }}>
          Behold the evolution of WaoTools! Find out what’s new, what’s fixed, or just take a trip down memory lane with
          a nostalgic swagger, remembering those bugs of yesterday.
        </Typography>
      </Card>

      {/* Releases List */}
      <Grid container spacing={3}>
        {releaseNotes.releases?.map(release => (
          <Grid size={{ xs: 12, md: 6, lg: 4 }} key={release.version}>
            <Card
              sx={{
                padding: '1.5rem',
                borderRadius: '12px',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                backgroundColor: theme.palette.background.paper,
                borderTop: `6px solid orange`, // Orange top border for other blocks
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%' // Make all blocks equal in height
              }}
            >
              <Typography variant='h6' component='h2' sx={{ fontWeight: 'bold', marginBottom: '1rem' }}>
                Version {release.version}
              </Typography>
              <Typography variant='body2' sx={{ marginBottom: '0.5rem' }}>
                <strong>Date:</strong> {fechaCorta(release.date)}
              </Typography>
              <Typography variant='body2' sx={{ marginBottom: '1rem', fontStyle: 'italic' }}>
                "{release.quote}"
              </Typography>

              <Divider sx={{ marginY: '1rem' }} />

              <Typography variant='body1' sx={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
                New ✨
              </Typography>
              {release.new.map((n, index) => (
                <Typography key={'new-' + index} variant='body2' sx={{ marginBottom: '0.5rem' }}>
                  <Icon icon='f7:gear-alt-fill' style={{ fontSize: '12px', marginRight: '5px' }} />
                  {n}
                </Typography>
              ))}

              <Typography variant='body1' sx={{ fontWeight: 'bold', marginTop: '1rem', marginBottom: '0.5rem' }}>
                Improvements 🙌
              </Typography>
              {release.improvements.map((n, index) => (
                <Typography key={'improvement-' + index} variant='body2' sx={{ marginBottom: '0.5rem' }}>
                  <Icon icon='f7:gear-alt-fill' style={{ fontSize: '12px', marginRight: '5px' }} />
                  {n}
                </Typography>
              ))}

              <Typography variant='body1' sx={{ fontWeight: 'bold', marginTop: '1rem', marginBottom: '0.5rem' }}>
                Bug Fixes 🐛
              </Typography>
              {release.bugs.map((n, index) => (
                <Typography key={'bug-' + index} variant='body2' sx={{ marginBottom: '0.5rem' }}>
                  <Icon icon='f7:gear-alt-fill' style={{ fontSize: '12px', marginRight: '5px' }} />
                  {n}
                </Typography>
              ))}
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  )
}

ReleaseNotes.noLoadingGate = true

export default ReleaseNotes
